// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateWishList-marginLeft-fkHgf {
    margin-left: 12px;
}

.CreateWishList-plusIconSection-QsWBG {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 54px;
    height: 54px;
    border: 1px solid var(--primary-border);
    border-radius: 6px;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    padding: 13px;
}

.CreateWishList-plusIcon-dFoRf {
    width: 100%;
    max-width: 24px;
    height: 24px;
    min-height: 24px;
}

.CreateWishList-createTextMargin-cNiOu {
    margin: 0px 18px;
}

.CreateWishList-btnPadding-c535R {
    padding: 8px 15px !important;
    font-size: 16px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/WishListModal/CreateWishList/CreateWishList.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,kBAAkB;IAClB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,0BAA0B;AAC9B","sourcesContent":[".marginLeft {\n    margin-left: 12px;\n}\n\n.plusIconSection {\n    display: flex;\n    width: 54px;\n    height: 54px;\n    border: 1px solid var(--primary-border);\n    border-radius: 6px;\n    align-items: center;\n    justify-content: center;\n    padding: 13px;\n}\n\n.plusIcon {\n    width: 100%;\n    max-width: 24px;\n    height: 24px;\n    min-height: 24px;\n}\n\n.createTextMargin {\n    margin: 0px 18px;\n}\n\n.btnPadding {\n    padding: 8px 15px !important;\n    font-size: 16px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"marginLeft": `CreateWishList-marginLeft-fkHgf`,
	"plusIconSection": `CreateWishList-plusIconSection-QsWBG`,
	"plusIcon": `CreateWishList-plusIcon-dFoRf`,
	"createTextMargin": `CreateWishList-createTextMargin-cNiOu`,
	"btnPadding": `CreateWishList-btnPadding-c535R`
};
module.exports = ___CSS_LOADER_EXPORT___;
